/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxCheckBoxComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxcheckbox';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcCheckBoxComponent),
    multi: true
};

/**
 * Check Box
 */

export class NgcCheckBoxComponent extends ControlComponent {
     animationShowDelay: any;
     animationHideDelay: any;
     boxSize: any;
     checked: any;
     enableContainerClick: any;
     groupName: any;
     hasThreeStates: any;
     locked: any;
     rtl: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.args.checked;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-checkbox',
    template: `<jqxCheckBox *ngIf="visible" (onChange)="inputChange($event)"
                [animationShowDelay] = "animationShowDelay"
                [animationHideDelay] = "animationHideDelay"
                [boxSize] = "boxSize"
                [checked] = "checked"
                [disabled] = "disabled"
                [enableContainerClick] = "enableContainerClick"
                [groupName] = "groupName"
                [hasThreeStates] = "hasThreeStates"
                [locked] = "locked"
                [rtl] = "rtl"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxCheckBox>
                <ngc-error [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animationShowDelay': [{ type: Input, args: ['animationShowDelay', ] },],
'animationHideDelay': [{ type: Input, args: ['animationHideDelay', ] },],
'boxSize': [{ type: Input, args: ['boxSize', ] },],
'checked': [{ type: Input, args: ['checked', ] },],
'enableContainerClick': [{ type: Input, args: ['enableContainerClick', ] },],
'groupName': [{ type: Input, args: ['groupName', ] },],
'hasThreeStates': [{ type: Input, args: ['hasThreeStates', ] },],
'locked': [{ type: Input, args: ['locked', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Check Box Module
 */

export class NgcCheckBoxModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcCheckBoxComponent],
    declarations: [NgcCheckBoxComponent, jqxCheckBoxComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
